import { useEffect } from 'react'
import { useAppSelector } from '../store'
import { setUser, addBreadcrumb } from '../lib/sentry'

export function useSentryUser() {
  const user = useAppSelector(state => state.app.user)
  const isReady = useAppSelector(state => state.app.isReady)

  useEffect(() => {
    if (isReady && user.email) {
      setUser({
        id: user.email,
        email: user.email,
        username: `${user.first_name} ${user.last_name}`.trim()
      })

      addBreadcrumb(`User logged in: ${user.email}`, 'auth', 'info')

      import('@sentry/react').then(Sentry => {
        Sentry.setTag('user.roles', user.roles.join(','))
        Sentry.setTag('user.permissions_count', user.permissions.length.toString())

        Sentry.setContext('user_details', {
          first_name: user.first_name,
          last_name: user.last_name,
          roles: user.roles,
          permissions: user.permissions,
          inheritance: user.inheritance
        })
      })
    } else if (isReady && !user.email) {
      import('@sentry/react').then(Sentry => {
        Sentry.setUser(null)
        addBreadcrumb('User logged out', 'auth', 'info')
      })
    }
  }, [user, isReady])
}

export function useSentryBreadcrumbs() {
  return {
    addUserAction: (action: string, category: string = 'user') => {
      addBreadcrumb(`User action: ${action}`, category, 'info')
    },
    addNavigation: (path: string) => {
      addBreadcrumb(`Navigated to: ${path}`, 'navigation', 'info')
    },
    addApiCall: (endpoint: string, method: string = 'GET') => {
      addBreadcrumb(`API call: ${method} ${endpoint}`, 'api', 'info')
    },
    addError: (error: string, context?: string) => {
      addBreadcrumb(context ? `Error in ${context}: ${error}` : `Error: ${error}`, 'error', 'error')
    }
  }
}
